import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import RecipieStyles from "./recipies.module.scss"
import Img from "gatsby-image"

const Recipies = ({ cat, title, text, btn, linkTekst }) => {

  const [expanded, setExpanded] = useState(false)

  const data = useStaticQuery(graphql`
  query MyQuery {
    allMarkdownRemark(sort: {fields: frontmatter___dato, order: DESC}, filter: {frontmatter: {content_type: {eq: "recipie"}}}) {
      nodes {
        frontmatter {
          title
          kategorier
          permalink
          thumbnail {
            publicURL
            childImageSharp {
              fluid(maxWidth: 250, quality: 50) {
                base64
                aspectRatio
                src
                srcSet
                srcWebp
                srcSetWebp
                sizes
              }
            }
          }
        }
      }
    }
    dataJson(content_type: {eq: "recipies_cat"}) {
      cat
      cat_colors {
        kategori
        temafarve
      }
    }
  }
  `)

const rec = data.allMarkdownRemark.nodes 
const recCat = rec.filter(r => r.frontmatter.kategorier.includes(cat))
const categories = data.dataJson.cat_colors
const themeColor = categories.find(c => c.kategori === cat) ? categories.find(c => c.kategori === cat).temafarve : 'Blå'
let styleColor = ''
let textColor = 'white'
let headingColor = ''
if(themeColor === 'Rød') {
  styleColor = 'red'
} else if(themeColor === 'Grøn') {
  styleColor = 'green'
} else if(themeColor === 'Pink') {
  styleColor = 'pink'
} else if(themeColor === 'Blå') {
  styleColor = 'blue'
} else {
  styleColor = 'white'
  textColor = 'black'
  headingColor = 'black'
}

const bgStyle = `bg-${styleColor}`
const colorStyle = `text-${styleColor}`

function createMarkup(html) {
  return {__html: html}
}

const [nRecipies, setNRecipies] = useState(4)

return (
  <section className="section">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12 space-xs-up">
            { title ? <h2 className={[headingColor ? `text-${headingColor}` : colorStyle, 'text-center'].join(' ')}>{ title }</h2> : null }
            { text ? <div className="text-center" dangerouslySetInnerHTML={createMarkup(text)}></div> : null }
            { btn ? <div className="col col-xs-12 center space-xs-down"><Link className="btn btn-secondary" to={btn}>{linkTekst}</Link></div> : null }
          </div>
        </div>
          <div className="row">
          <div className={["col col-xs-12 text-bold space-small-xs-up", `text-${styleColor}`].join(' ')}><p className="pull-right">{nRecipies < recCat.length ? `${nRecipies} / ${recCat.length}` : `${recCat.length} / ${recCat.length}` }</p></div>
            {recCat.map((r, i) => {
            if(i <= nRecipies - 1) {
              return (

                <div key={i} className="col col-xs-12 col-sm-6 col-lg-4 col-xl-3">
                <Link className={RecipieStyles.link} to={`/opskrifter/${r.frontmatter.permalink}`}>
                   <div className={RecipieStyles.card} >
                    <div className={[RecipieStyles.bgWrapper, bgStyle].join(' ')}>
                      <div className={RecipieStyles.bgWrapperInner}>
                        { r.frontmatter.thumbnail && r.frontmatter.thumbnail.childImageSharp ? 
                        <Img fadeIn={false} fluid={r.frontmatter.thumbnail.childImageSharp.fluid} className={RecipieStyles.bg} alt={r.frontmatter.title}/>
                        : r.frontmatter.thumbnail && r.frontmatter.thumbnail ? 
                        <img src={r.frontmatter.thumbnail.publicURL} className={RecipieStyles.bg} alt={r.frontmatter.title} />
                        : 
                        <h4 className={['text-center', `text-${textColor}`, RecipieStyles.linkUnstyled].join(' ')}>{r.frontmatter.title}</h4>
                        }
                    </div>
                    </div>
                    { r.frontmatter.thumbnail ?
                    <div className={[RecipieStyles.textBox, bgStyle].join(' ')}>
                      <h6 className={['text-center', `text-${textColor}`, RecipieStyles.linkUnstyled].join(' ')}>{r.frontmatter.title}</h6>
                    </div>
                    : null }
                    
                  </div>
                  </Link>
                </div>
                
              )
            }
            })}
            
            
            
            {nRecipies < recCat.length ?
            <div className="col col-xs-12 round-button display-block-center">
              <button className="btn btn-secondary btn-round display-block-center" onClick={() => {
                setNRecipies(nRecipies + 4);
                setExpanded(!expanded);
                }
              }>
                <span className={["expand", expanded ? "expanded" : ""].join(' ')}></span>
              </button>
                <p className="round-btn-text">Se flere</p>
            </div>
            : null}
           
          </div>
      </div>
  </section>
)}

export default Recipies